import * as Sentry from '@sentry/nextjs';
import { takeLatest, select, call, put } from 'redux-saga/effects';
import { getCurrentTeam } from 'api';
import {
  GET_TEAM_REQUEST,
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNED_SUCCESS,
} from 'redux-api/action/actionTypes';
import selectAuth from 'redux-api/reselect/auth';
import * as teamActions from 'redux-api/action/teams';

function* getTeamSaga() {
  try {
    const { signInUserSession } = yield select(selectAuth);
    const { accessToken } = signInUserSession || {};

    if (!accessToken) return null;

    const { data } = yield call(getCurrentTeam, accessToken);

    return yield put(teamActions.getTeamSuccess(data?.data || {}));
  } catch (err) {
    // Fail-open: don't block sections if the team endpoint is unavailable.
    Sentry.captureException(err);

    return yield put(teamActions.getTeamFailure(err));
  }
}

export default function* watchTeams() {
  yield takeLatest(GET_TEAM_REQUEST, getTeamSaga);
  yield takeLatest(AUTH_SIGNIN_SUCCESS, getTeamSaga);
  yield takeLatest(AUTH_SIGNED_SUCCESS, getTeamSaga);
}
